import * as React from 'react';
import { ProtectedRoutes, RouteGroups } from '../router-x/routes';
import { Link, useLocation } from 'react-router-dom';
import { Chip, Drawer, IconButton, List, ListItem, Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';
import { ArrowUpRightIcon, ChevronRightIcon, LogOutIcon, MenuIcon, PanelLeftCloseIcon } from 'lucide-react';
import { SignOut } from '../services/firebase/auth';
import { useAuth } from '../services/contexts/authContext';
import NexusLogo from '../assets/nexus-logo-horizontal.svg';
import NexusIcon from '../assets/nexus-icon.svg';
import { subscribeToValue } from '../services/firebase/rtdb';
import { convertToPresentableText } from '../utils/functions';
// const drawerWidth = 240;

const ParentContainer = (props) => {
	const { children } = props;
	const location = useLocation();
	// const [mobileOpen, setMobileOpen] = React.useState(false);
	// const [isClosing, setIsClosing] = React.useState(false);
	const [open, setOpen] = React.useState(false);
	const [userNotificationsCount, setUserNotificationsCount] = React.useState(0);

	const openDrawer = () => setOpen(true);
	const closeDrawer = () => setOpen(false);

	const { userDetails } = useAuth();

	//67c60bde28292140b97d5a6b
	React.useEffect(() => {
		const unsubscribe = subscribeToValue(`userNotifications/${userDetails?._id}`, (data) => {
			setUserNotificationsCount(data?.unreadCount || 0);
		});
		return () => {
			unsubscribe();
		};
	}, [userDetails?._id]);


	// const handleDrawerClose = () => {
	//   setIsClosing(true);
	//   setMobileOpen(false);
	// };

	// const handleDrawerTransitionEnd = () => {
	//   setIsClosing(false);
	// };

	// const handleDrawerToggle = () => {
	//   if (!isClosing) {
	//     setMobileOpen(!mobileOpen);
	//   }
	// };

	const groupEntries = Object.entries(RouteGroups);
	const allPermissibleRoutes = ProtectedRoutes.filter(item => item.inSideBarList === true && (item.permissibleRoles.includes(userDetails.role)));
	const groups = {};
	for (let i = 0; i < groupEntries.length; ++i) {
		const [key, value] = groupEntries[i];
		const routes = allPermissibleRoutes.filter(item => item.group === value); // routes that are in the group	
		if (routes.length > 0) {
			groups[key] = routes;
		}
	}


	const drawer = (
		<div>
			<div className='flex flex-col items-center justify-center mt-3 px-4 py-3'>
				<img src={NexusLogo} alt='Nexus' className='h-12 w-auto max-w-[200px]' />
				<span className='text-gray-900 text-xs font-thin mt-1'>
					Powered by Protovoid Technologies
				</span>
			</div>
			<hr className='my-5' />
			<List className='min-w-full'>
				{allPermissibleRoutes.filter(item => item.group === null).map((route, index) => (
					<Link key={index} to={route.path} onClick={closeDrawer}>
						<ListItem className='rounded-full' selected={location.pathname === route.path}>
							<div className='flex items-center justify-between w-full'>
								<div className="flex items-center">
									<div className="pr-3">
										{route.icon}
									</div>
									<div className="text-sm font-thin flex">
										{route.name}
										{
											['FX7-1'].includes(route.id) && userNotificationsCount > 0 &&
											<Chip
												size='sm'
												variant='ghost'
												color='red'
												value={userNotificationsCount}
												className='ml-2 px-2 py-0 rounded-full' />}
									</div>
								</div>
								<div>{route.secondaryIcon}</div>
							</div>
						</ListItem>
					</Link>
				))}
				<hr className='my-2' />
				<div className='hidden md:block'>
					{
						Object.entries(groups).map(([key, value]) => (
							<Menu placement='right-start' key={key}>
								<MenuHandler>
									<ListItem className='rounded-full' >
										<div className="flex items-center justify-between w-full">
											<div className="flex items-center gap-2">
												<div>
													<ArrowUpRightIcon size={16} />
												</div>
												<div className='text-sm font-thin'>
													{convertToPresentableText(key.toLowerCase())}
												</div>
											</div>
											<div className="text-sm font-thin">
												<ChevronRightIcon size={16} />
											</div>
										</div>
									</ListItem>
								</MenuHandler>
								<MenuList>
									{
										value.filter(item => item.inSideBarList === true && (item.permissibleRoles.includes(userDetails.role))).map((route, index) => (
											<Link key={index} to={route.path}>
												<MenuItem>
													<div className='flex items-center gap-2'>
														<div className='text-sm font-thin'>
															{route.icon}
														</div>
														<div className='text-sm font-thin'>
															{route.name}
														</div>
													</div>
												</MenuItem>
											</Link>
										))
									}
								</MenuList>
							</Menu>
						))
					}
				</div>
				<div className='block md:hidden'>
					{
						Object.entries(groups).map(([key, value]) => (
							<Menu placement='bottom' key={key}>
								<MenuHandler>
									<ListItem className='rounded-full' >
										<div className="flex items-center justify-between w-full">
											<div className="flex items-center gap-2">
												<div>
													<ArrowUpRightIcon size={16} />
												</div>
												<div className='text-sm font-thin'>
													{convertToPresentableText(key.toLowerCase())}
												</div>
											</div>
											<div className="text-sm font-thin">
												<ChevronRightIcon size={16} />
											</div>
										</div>
									</ListItem>
								</MenuHandler>
								<MenuList className='z-[10000]'>
									{
										value.map((route, index) => (
											<Link key={index} to={route.path}>
												<MenuItem onClick={closeDrawer}>
													<div className='flex items-center gap-2'>
														<div className='text-sm font-thin'>
															{route.icon}
														</div>
														<div className='text-sm font-thin'>
															{route.name}
														</div>
													</div>
												</MenuItem>
											</Link>
										))
									}
								</MenuList>
							</Menu>
						))
					}
				</div>
				<hr className='my-2' />
				<ListItem className='rounded-full' onClick={() => SignOut()}>
					<div className="flex items-center">
						<div className="pr-3">
							<LogOutIcon size={16} />
						</div>
						<div className="text-sm font-thin">
							Logout
						</div>
					</div>
				</ListItem>
			</List>
		</div>
	);


	return (
		<React.Fragment>
			<div className="flex">
				<div className="w-[250px] h-screen overflow-y-auto border-r hidden md:block z-10">
					{drawer}
				</div>
				<div className="w-full md:w-[calc(100%-250px)] h-screen overflow-y-auto">
					<div className={`h-[120px] p-5 w-full md:hidden`}>
						<div className={`rounded-3xl border p-5 flex justify-between items-center`}>
							{/* <img src={LOGO} alt='logo' className='max-h-[50px] max-w-[170px]' /> */}
							<div className='flex items-center gap-2'>
								<img src={NexusIcon} alt='Nexus' className='h-10 w-10' />
							</div>
							<IconButton className='rounded-full' size='sm' onClick={openDrawer}>
								<MenuIcon size={12} />
							</IconButton>
						</div>
					</div>
					{children}
				</div>
			</div>
			<Drawer open={open} onClose={closeDrawer}>
				<div className={``}>
					<div className={`h-screen overflow-y-auto`}>
						{drawer}
					</div>
					<div className={`h-screen overflow-y-auto`}>
						<hr />
						<div className={`flex justify-end`}>
							<IconButton className='rounded-full' variant='text' size='lg' onClick={closeDrawer}>
								<PanelLeftCloseIcon size={24} />
							</IconButton>
						</div>
					</div>
				</div>
			</Drawer>
		</React.Fragment>
	);
}

export default ParentContainer;
